module.exports = __webpack_public_path__ + "et.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/et.svg
// module id = 794
// module chunks = 0